var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "51px",
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 50 0 50 50.0070074 0 50.0070074"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "null",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webmobil-\\u2013-Nuevo-Inicio",
    transform: "translate(-160.000000, -2365.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(160.000000, 2365.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8660362,24.995172 C44.9581001,14.1253688 35.9272308,5.08697406 25.0196051,5.05856481 C14.1292781,5.03028924 5.07387791,14.0195246 5.05851451,24.9462081 C5.04328766,35.816109 14.0140516,44.854406 24.9217749,44.882913 C35.8120042,44.9111886 44.927119,35.9221487 44.8660362,24.995172 M22.9223645,0 L27.0191133,0 C28.1761678,0.156567386 29.3356656,0.29270869 30.4771806,0.552872474 C43.8643763,3.60466598 52.4525177,16.8350988 49.3740432,30.4919382 C46.352449,43.8962371 33.0624972,52.5414542 19.4395709,49.3392504 C9.9443746,47.1072367 3.79690571,41.0620937 0.882621763,31.7511231 C0.400898513,30.2119348 0.191262406,28.6157684 0,27.0191133 L0,22.9223645 C0.154221807,21.7650168 0.266027731,20.5994596 0.557172702,19.4657631 C2.98758329,10.0006685 8.86599474,3.80052181 18.1928957,0.881839903 C19.7312045,0.400409851 21.326589,0.191164674 22.9223645,0",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.8800623,24.9765931 C18.8800623,22.7991141 18.8795737,20.6215373 18.8806487,18.4440583 C18.8807465,18.1678664 18.8785964,17.8910881 18.8947222,17.6155804 C18.9800426,16.15018 20.1415928,15.4095635 21.496751,15.9696681 C21.8701867,16.1239877 22.2240759,16.3303009 22.575424,16.5328025 C26.291505,18.6750001 30.0057291,20.8203251 33.7183894,22.9683867 C33.999077,23.1307203 34.2789828,23.3012634 34.5333803,23.5008331 C35.6066781,24.3427004 35.6131284,25.5911347 34.5416876,26.4321225 C34.2239594,26.6815357 33.8691906,26.8872625 33.5182334,27.0902528 C29.7632549,29.2626497 26.0060285,31.4309419 22.2481181,33.5982567 C22.0374069,33.7197381 21.8209295,33.8339874 21.5983927,33.932013 C20.1584028,34.5664921 18.9343039,33.8138545 18.8962859,32.2400688 C18.8625682,30.8433744 18.8824079,29.4453117 18.8803555,28.0478353 C18.8787918,27.0240879 18.8800623,26.0003405 18.8800623,24.9765931",
    id: "Fill-4",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.2035b06d90f41fda06954a38815aef2b.svg";
export { ForwardRef as ReactComponent };